import {OauthService} from './oauth.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {Http} from '@angular/http';
import {App} from 'ionic-angular';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class ReducceTopService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }


  getTop(id: string): Observable<any> {
    const url = this.Routing.generate('api_get_reduccesousgenretop_ces', { '_format': 'json', 'sousgenreId': id}, true);

    return this.http.get(url , {headers: this.updateHeaders()}).map(response => response.json().data)
  }

  updateTop(top: any): Observable<any> {
    const url = this.Routing.generate('api_put_reduccesousgenretop_ce_status_update', {}, true);

    return this.http.put(url, top, {headers: this.updateHeaders()}).map(response => response.json().data)
  }

  getStar(index, top) {
    if (top.top >= index) {
      return true
    } else {
      return false
    }
  }

  setTop(index, top) {
    if (index == top.top ) {
      top.top = index -1;
    } else {
      top.top = index
    }
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/reducce-top.service.ts